import { bindLoginStateChangedAsync as bindLoginStateChangedAsync } from '@/utils/wps-fn';

export function configWpsClient() {
  // 开启自动注入监听客户端事件, 登录登出事件监听;
  bindLoginStateChangedAsync();
}
